import { BaseRouteService } from "core/services";

class InventoryCalculationCutbackRouteService extends BaseRouteService {
	constructor() {
		super("inventory-calculation-cutbacks");
	}

	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,templateItemId,calculationItemId}`, filter);
	}

	batchUpdate(resource) {
		return super.batchUpdate(`${this.base}/batch`, resource);
	}

	updateCutbackAdjustedQty(resource) {
		return super.update(`${this.base}/update-cutback-adjusted-qty`, resource);
	}
	
	updateCutbackAdjustedQtyNewFlow(resource) {
		return super.update(`${this.base}/update-cutback-adjusted-qty-new-flow`, resource);
	}

	updateCutbackAdjustedQtyNikoFlow(resource) {
		return super.update(`${this.base}/update-cutback-adjusted-qty-niko-flow`, resource);
	}
}

export default InventoryCalculationCutbackRouteService;